// extracted by mini-css-extract-plugin
export default {"control":"LanguagePicker_control__ggBoZ","label":"LanguagePicker_label__p8wr5","icon":"LanguagePicker_icon__a5k0O"};